import { Switch } from 'antd';
import './VtxSwitch.scss';
import * as React from 'react';
import { SwitchProps } from 'antd/lib/switch';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxSwitchProps extends Omit<SwitchProps, 'size' | 'onChange' | 'onClick'>, IAutomatable {
    /**
     * @default default
     */
    size?: 'default' | 'small';
    onChange?: (checked: boolean, event: MouseEvent) => void;
    onClick?: (checked: boolean, event: MouseEvent) => void;
}

export const VtxSwitch: FunctionComponent<VtxSwitchProps> = React.memo((props: VtxSwitchProps) => {
    const automationClass = 'vtx-switch';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);

    return (
        <Switch
            className={classNamesCombined}
            data-automation-class={automationClass}
            {...otherProps}
        ></Switch>
    );
});
